import type { cityItem, airlineItem, airportItem, flightResponseItem } from '@/model/baseModel';

//params 数据放到请求 params中
interface resObject {
  success?: boolean;
  msg?: string;
  errorCode?: number;
  code?: number;
  body?: any;
}

interface cityResObject {
  success?: boolean;
  msg?: string;
  errorCode?: number;
  code?: number;
  body?: cityItem[];
}
interface airportResObject {
  success?: boolean;
  msg?: string;
  errorCode?: number;
  code?: number;
  body?: airportItem[];
}
interface carrierResObject {
  success?: boolean;
  msg?: string;
  errorCode?: number;
  code?: number;
  datas?: airlineItem[];
  status: number;
}
interface flightResObject {
  success?: boolean;
  msg?: string;
  errorCode?: number;
  code?: number;
  body?: flightResponseItem[];
}
interface airportResObject2 {
  msg?: string;
  status?: number;
  datas?: any[];
}
export const ApiGetCity = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/bdmini/data/city/list')
      .then((data: any) => {
        let res = data.data._value;
        if (res.code == 200) {
          resolve(res.body);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiGetAirport = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/bdmini/data/airport/list')
      .then((data: any) => {
        let res = data.data._value;
        if (res.code == 200) {
          resolve(res.body);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiGetCarrier = () => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/order-url/PolarisOrder/airline/list')
      .then((data: any) => {
        let res = data.data._value;
        if (res.status == 0) {
          resolve(res.datas);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiGetCountry = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/bdmini/data/country/list')
      .then((data: any) => {
        let res = data.data._value;
        if (res.code == 200) {
          resolve(res.datas);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};

export const ApiGetAll = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/order-url/PolarisOrder/airports/list')
      .then((data: any) => {
        let res = data.data._value;
        if (res.status == 0) {
          resolve(res.datas);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiGetAirportsList = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/content-url/rest/airport/search', params)
      .then((data: any) => {
        let res = data.data._value;
        if (res.status == 0) {
          resolve(res);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiGetAirportsCountrylist = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/content-url/rest/airport/countrylist', params)
      .then((data: any) => {
        let res = data.data._value;
        if (res.status == 0) {
          resolve(res);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiGetCurrency = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/order-url/PolarisOrder/channel/currency', params)
      .then((data: any) => {
        let res = data.data._value;
        if (res.status == 0) {
          resolve(res);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
// 支付校验
export const ApiPayCheck = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/order-url/PolarisOrder/pay/check', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};